import React, { useState } from "react";

import AllCarrier from "../../components/AdminSideComponents/Carrier/AllCarrier";
import AddCarrierModal from "../../components/AdminSideComponents/Carrier/AddCarrierModal";

const AuthCarrier = () => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const handleRefresh = () => setRefresh((prev) => !prev);

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-8">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Carrier</h1>
          <p className="text-sm text-gray-500 mt-1">
            Manage your carrier posts
          </p>
        </div>
        <button
          onClick={() => setShowAddModal(true)}
          className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-5 py-2.5 rounded-lg font-medium transition"
        >
          <span className="text-xl leading-none">+</span> Add Carrier
        </button>
      </div>

      <AllCarrier refresh={refresh} onRefresh={handleRefresh} />

      {showAddModal && (
        <AddCarrierModal
          onClose={() => setShowAddModal(false)}
          onSuccess={() => {
            setShowAddModal(false);
            handleRefresh();
          }}
        />
      )}
    </div>
  );
};

export default AuthCarrier;
